import React from 'react';
import { Outlet } from 'react-router-dom';

function RolesGuard() {
  return <Outlet />;
}

export default RolesGuard;
